import type { DietaryProperty } from '@sg/graphql-schema';

import { type DietaryPreferencesTypes } from '../../machines';

/**
 * Returns a formatted string of matched dietary restrictions
 * between user dietary restrictions and provided dietary properties.
 */
export const getProductDietaryRestrictionsNames = (
  userRestrictions: DietaryPreferencesTypes,
  dietaryProperties: readonly DietaryProperty[] | undefined,
) => {
  const activeRestrictions = (dietaryProperties ?? []).filter(
    (property) => userRestrictions[property.name],
  );
  const restrictionNames = activeRestrictions.map((restriction) => restriction.name.toLowerCase());

  return restrictionNames.join(', ');
};
